<!-- src/components/RecoveryProcess.vue -->
<template>
  <div class="recovery-process">
    <!-- Banner Section with Image -->
    <section class="banner">
      <img src="../assets/step.jpg" alt="Recovery Center" />
    </section>

    <header>
      <h1>The Recovery Process in Our Rehabilitation Center</h1>
      <p>A supportive journey to overcoming addiction, finding strength, and building a fulfilling life.</p>
    </header>

    <section class="section">
      <h2>What is the Recovery Process?</h2>
      <p>
        The recovery process in our rehabilitation center is a structured approach designed to help individuals
        overcome addiction, address underlying issues, and develop the skills needed for long-term sobriety.
        This journey is guided by experienced professionals who provide personalized support at every step.
      </p>
    </section>

    <section class="section">
      <h2>Phases of the Recovery Process</h2>
      <p>Our recovery process consists of several key phases:</p>
      <ol>
        <li><strong>Assessment and Intake:</strong> Initial evaluations to understand individual needs and create a tailored plan.</li>
        <li><strong>Detoxification:</strong> A medically supervised phase to safely manage withdrawal symptoms and cleanse the body of substances.</li>
        <li><strong>Therapeutic Counseling:</strong> One-on-one and group therapy sessions to address root causes of addiction and build coping skills.</li>
        <li><strong>Life Skills Development:</strong> Practical workshops and classes that help individuals regain independence and self-sufficiency.</li>
        <li><strong>Aftercare Planning:</strong> Preparing for life beyond rehabilitation, including support networks and follow-up counseling.</li>
      </ol>
    </section>

    <section class="section">
      <h2>Support Throughout the Journey</h2>
      <p>
        Our center prioritizes a compassionate and holistic approach to recovery, providing a safe environment
        where individuals feel supported and empowered. From health monitoring and therapeutic activities to
        family involvement and aftercare services, we’re here to help each person build a fulfilling, sober life.
      </p>
    </section>

    <footer class="footer">
      <p>If you or someone you know needs support, consider our rehabilitation center as a resource for guidance and healing.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'RecoveryProcess'
};
</script>

<style scoped>
.recovery-process {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  padding: 20px;
  max-width: 800px;
  margin: auto;
}

.banner {
  padding: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.banner img {
  width: 100%;
  max-width: 700px;
  border-radius: 8px;
}

header {
  text-align: center;
  margin-bottom: 20px;
}

h1 {
  color: #2c3e50;
}

.section {
  margin-bottom: 20px;
}

.section h2 {
  color: #2c3e50;
  font-size: 1.5em;
  margin-top: 10px;
}

ol {
  margin-left: 20px;
  list-style-type: decimal;
}

.footer {
  margin-top: 20px;
  text-align: center;
  font-weight: bold;
  color: #555;
}
</style>
